import EcoSpace from 'eco-design/base/eco-space';
import PlaneCard from './PlaneCard';
import styled from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA2');

    const lists = [
        {
            title: t('data1'),
            sup: t('data1_sup'),
            desc: t('data1_desc'),
        },
        {
            title: t('data2'),
            sup: t('data2_sup'),
            desc: t('data2_desc'),
        },
        {
            title: t('data3'),
            sup: t('data3_sup'),
            desc: t('data3_desc'),
        },
    ];

    return (
        <div className={styled.SectionA2}>
            <EcoSpace />
            <PlaneCard
                title={t('title')}
                desc={t('desc')}
                isVideo={true}
                lists={lists}
                pc="https://websiteoss.ecoflow.com/upload/video/1751512231471/20250703-105719%20(1).mp4"
                h5="https://websiteoss.ecoflow.com/upload/video/1751512231471/20250703-105719%20(1).mp4"
            />
        </div>
    );
}
